import { h } from 'preact';
import { useMemo } from 'preact/hooks';
import { useNewStore, usePlayerContext } from '../../../common/hooks';
import { useVisibleClass } from '../../../common/utils/tools';
import { withBreakPoints } from '../../hoc';
import { HeaderInfos } from '../info';
import TrackFeedBack from '../info/tracks/TrackFeedBack';
import { SECTION_TOP_DEFAULT_STYLE } from './styles';

function SectionTop() {
  const player = usePlayerContext();
  const { subtitleSelected, textTrack } = useNewStore('subtitles', usePlayerContext());
  const { zappingEnabled } = useNewStore('zapping');
  const { canInteract, waitStart, isFullscreen, currentBreakpoint, UIVisible } = useNewStore('ui', player);
  const { isAd } = useNewStore('ad');
  const isHeaderInfoHidden = useMemo(
    () => (!UIVisible || waitStart || !canInteract)
      // Hide on xs,s in full screen when zapping enabled
      || ((isFullscreen) && zappingEnabled && (['xs', 'sm'].includes(currentBreakpoint))),
    [canInteract, currentBreakpoint, isFullscreen, waitStart, zappingEnabled, UIVisible]
  );

  return (
    <div
      className={`magneto--section-top ${useVisibleClass(!isAd)}`}
      style={SECTION_TOP_DEFAULT_STYLE}
    >
      <HeaderInfos hidden={isHeaderInfoHidden} containerVisible={UIVisible} />
      <TrackFeedBack
        track={textTrack}
        trackSelected={subtitleSelected}
        type="Sous-titres"
      />
    </div>
  );
}

export default withBreakPoints(SectionTop);
